import { AnalyticsType, getAnalyticTags, gotoUrl } from "@menu/core/lib";
import MenuContext, { DisplayItem } from "@menu/core/menu.context";
import { observer } from "mobx-react-lite";
import { CountryFlagIcon, ProfileIcon } from "../shared";
import TopNavLink from "../shared/top-nav-link";

type TopNavProps = {
  context: MenuContext;
};

const TopNav = observer((props: TopNavProps) => {
  const { context } = props;

  const dictionary = context.dictionary;

  const url = context.authService.getSignInUrl();

  const analyticTags = getAnalyticTags({
    component_name: context.isLoggedIn ? "profile_click" : "signin_click",
    nav_item: AnalyticsType.topLevel,
    nav_text: "sign_in",
    target_page_url: url,
  });

  const clickFlag = (e: Event) => {
    e.preventDefault();
    e.stopPropagation();

    const itemToDisplay = context.displayChannelMenu
      ? DisplayItem.MainNav
      : DisplayItem.Channels;

    context.updateDisplayItem(itemToDisplay);
    context.updateDisplayMobileNav(true, true);
  };

  const handleLoginClick = () => {
    if (!context.isLoggedIn) {
      return context.authService.signIn();
    }

    //Further clarification needed on where to navigate if you are logged in
  };

  const goToBusinessSite = () => {
    if (context.isBusinessSite) {
      return;
    }

    gotoUrl(context.siteUrls.business);
  };

  const goToResidentialSite = () => {
    if (!context.isBusinessSite && !context.isMediaSalesSite) {
      return;
    }

    gotoUrl(context.siteUrls.main);
  };

  const getUserProfile = () => {
    const isLoggedIn = context.isLoggedIn;

    if (isLoggedIn) {
      return <ProfileIcon context={context} />;
    }

    return (
      <div className="login" onClick={handleLoginClick} {...analyticTags}>
        <i className="icon-login"></i>
        <span>{dictionary.dstvLogin}</span>
        <i className="icon-more"></i>
      </div>
    );
  };

  const cssClassName =
    "user-profile" + (context.isLoggedIn ? " user-active" : "");

  return (
    <nav className="top-nav">
      <div className="top-nav-container">
        <div className="nav-selector">
          <TopNavLink
            title={dictionary.dstvForMe}
            isSelected={!context.isBusinessSite}
            onClick={goToResidentialSite}
          />

          <TopNavLink
            title={dictionary.dstvForBusiness}
            isSelected={context.isBusinessSite}
            onClick={goToBusinessSite}
          />
        </div>

        <span className="profile-section">
          <div className={cssClassName}>{getUserProfile()}</div>
          <div className="country-flag">
            <CountryFlagIcon
              context={context}
              countryCode={context.countryCode}
              onClick={clickFlag}
            />
          </div>
        </span>
      </div>
    </nav>
  );
});

export default TopNav;
